module.exports = __webpack_public_path__ + "officialStatic/img/index-product-system.6955b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/index-product-system.png
// module id = bqtu
// module chunks = 0